import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutlet } from "react-router";
import { useApp } from "../context";
import { Question } from "../parse";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(2),
  },
  headerButtons: {
    display: "flex",
    gap: theme.spacing(1),
    float: "right",
  },
  listItem: {
    paddingRight: 220,
  },
}));

export const AdminQuestionRoute = observer(function AdminQuestionRoute() {
  const app = useApp();
  const classes = useStyles();
  const navigate = useNavigate();
  const outlet = useOutlet();
  const { t } = useTranslation();

  const onCreate = () => {
    app.admin.create(Question.className).then((id) => {
      navigate(`/admin/question/edit/${id}`);
    });
  };

  const onBatchUpload = () => {
    navigate("/admin/question/batch-upload");
  };

  if (outlet) {
    return outlet;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h2" className={classes.padding}>
          <div className={classes.headerButtons}>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={onBatchUpload}
            >
              {t("button-batch-upload")}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={onCreate}
            >
              {t("button-new")}
            </Button>
          </div>
          {t("admin-questions-management")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <List>
          {app.benchmarks.questions.map((question) => {
            const onEdit = () => {
              navigate(`/admin/question/edit/${question.id}`);
            };

            const onDelete = () => {
              app.admin.delete(Question.className, question.id);
            };

            const categoryName =
              app.benchmarks.categories.find(
                (cat) => cat.id === question.category?.id,
              )?.name || t("none");

            return (
              <ListItem
                key={question.id}
                button
                onClick={onEdit}
                className={classes.listItem}
              >
                <ListItemText
                  primary={question.name}
                  secondary={`${t("category")}: ${categoryName} | ${
                    question.synthetic ? t("synthetic") : t("real")
                  }`}
                />
                <ListItemSecondaryAction>
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={onEdit}
                    style={{ marginRight: 8 }}
                  >
                    {t("button-edit")}
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    color="secondary"
                    onClick={onDelete}
                  >
                    {t("button-delete")}
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
});
